import { render, staticRenderFns } from "./SidebarSnapshot.vue?vue&type=template&id=9984fa52"
import script from "./SidebarSnapshot.vue?vue&type=script&lang=js"
export * from "./SidebarSnapshot.vue?vue&type=script&lang=js"
import style0 from "./SidebarSnapshot.vue?vue&type=style&index=0&id=9984fa52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports